import React, { useState } from 'react';
import { Field } from 'react-final-form';
import { TextField } from '@material-ui/core';
import { TextFieldInterface, FieldInterface } from './types';
import MenuItem from '@mui/material/MenuItem';
import strings from '../../resources/strings';

const MAX_TITLE_LENGTH = 25;

const FieldTextInputComponent: React.FC<TextFieldInterface> = (props) => {
    const [helperText, setHelperText] = useState<string>('');
    const { input, select, ...rest } = props;
    const { onChange } = input;
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (
            (event.target.name.split('_')[0] == 'name' ||
                event.target.name.split('_')[0] == 'stagesTitle' ||
                event.target.name.split('_')[0] == 'exercisesTitle') &&
            event.target.value.length >= MAX_TITLE_LENGTH
        ) {
            setHelperText(strings.missions.addMissionDialog.maxTitleLength);
            return;
        }
        setHelperText('');
        onChange(event);
    };

    return (
        <TextField
            fullWidth
            select={select}
            {...input}
            {...rest}
            onChange={handleInputChange}
            helperText={helperText}
            error={helperText.length > 0}
        ></TextField>
    );
};

const FieldTextInput: React.FC<FieldInterface> = (props) => {
    return (
        <Field
            initialValue={props.value}
            component={FieldTextInputComponent}
            {...props}
            select={props.select}
            defaultValue={props.defaultValue}
            style={{ display: props.hidden ? 'none' : 'block' }}
        >
            {props.data
                ? props.data.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                          {option.label}
                      </MenuItem>
                  ))
                : ''}
        </Field>
    );
};

export default FieldTextInput;
